export const calcUsedConstructionActions = (currentPlayer, pendingBuildings, nextInitiativePlayerId, isInitiativeInterceptedWithIsolationism) => {
  // Если игрок перехватил инициативу - он тратит одно действие
  const initiativeTaken = (nextInitiativePlayerId === currentPlayer.id
    && !isInitiativeInterceptedWithIsolationism)
    ? 1 : 0;
  const marketCleared = currentPlayer.isClearedPolicyMarketThisTurn ? 1 : 0;

  const noFreeActionsBuildings = pendingBuildings.filter(action => !action.isFreeAction);

  return noFreeActionsBuildings.length + initiativeTaken + marketCleared;
}